module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/is-browser/client.js
 ** module id = 76
 ** module chunks = 0
 **/